const ISO: any = {
    ar: "arabic",
    as: "assamese",
    be: "belarusian",
    bn: "bengali",
    my: "burmese",
    zh: "chinese",
    cs: "czech",
    en: "english",
    fr: "french",
    ka: "georgian",
    de: "german",
    el: "greek",
    he: "hebrew",
    hi: "hindi",
    hu: "hungarian",
    it: "italian",
    ja: "japanese",
    kn: "kannada",
    ko: "korean",
    no: "norwegian",
    pl: "polish",
    ru: "russian",
    sd: "sindhi",
    es: "spanish",
    sv: "swedish",
    th: "thai",
    tr: "turkish",
    uk: "ukrainian",
    ur: "urdu",
    ug: "uyghur",
};

export default ISO;
